import Inputc from '../../components/input.vue'
import {MD5Util} from '../../common/MD5Util.js';
import {api, msg} from '../../common/config.js';
import {ajaxUtil} from '../../common/AjaxUtil.js';
import {CommonUtil} from '../../common/CommonUtil.js';
import {store} from '../../store/store.js';
import {StorageUtil} from '../../common/Auth.js';
export default {
  name: 'changepwd',
  components: {
    Inputc,
  },
  data() {
    return {
      id: '',//读者id
      newPassword: '',//新密码
      newPassword2: '',
      oldPassword: '',//旧密码
      isClickBtn: false,
    }
  },
  beforeRouteEnter (to, from, next){
    next(vm => {
      // 通过 `vm` 访问组件实例,将值传入oldUrl
      StorageUtil.storeString("historyPath",from.fullPath);
    })
  },
  beforeDestroy:function(){
    StorageUtil.removeObject("historyPath");
  },
  mounted() {
    if (store.func.getUserObj() == null) {
      store.index.$refs.login.showLogin();
      return;
    }
    var url = api.personalnews.overdue.replace('{idCard}', store.user.idCard);
    ajaxUtil.ajaxJson(url, null, 'GET', (data) => {
    }, (result) => {
      /*if (result.errorCode == 30100) {
        if (result.message === '登录超时,请重新登录') {
          store.index.$refs.login.showLogin();
          return;
        }
        store.index.$refs.login.showLogin();
      }*/
    }, this);
  },
  methods: {
    submit: function () {
      if (this.isClickBtn) {
        return;
      }
      this.isClickBtn = true;
      var _this = this;
      if (!_this.validatePass()) {
        this.isClickBtn = false;
        return;
      }
      var url = api.reader.updatePassword;
      var newPass = MD5Util.hex_md5(_this.newPassword2);
      var oldPass = MD5Util.hex_md5(_this.oldPassword);
      var submitData = {
        id: store.func.getUserObj().readerId,
        newPassword: newPass,
        oldPassword: oldPass,
      };
      ajaxUtil.ajaxJson(url, submitData, 'POST', (data) => { //成功
        this.newPassword = '';
        this.newPassword2 = '';
        this.oldPassword = '';
        store.user = null;
        StorageUtil.removeObject('user');
        var historyPath = StorageUtil.getString("historyPath");
        if(historyPath != null) {
          store.wrap.user = null;
          this.$router.push(historyPath);
          StorageUtil.removeObject("historyPath");
        }
        store.index.$refs.login.showLogin();
      }, (result) => { //失败
        if (result.errorCode == 30107) {
          _this.$refs.a.showError("密码错误!");
          this.newPassword = '';
          this.newPassword2 = '';
        } else {
          CommonUtil.setResultTip(_this.$refs.resultTip, "修改密码失败!");
        }
        _this.isClickBtn = false;
      }, _this);
    },

    /**
     * 检查密码格式
     */
    validatePass: function () {
      var _this = this;
      if (_this.oldPassword.length < 6 && _this.oldPassword.length > 0) {
        this.$refs.a.showError(msg.passCountError);
        return false;
      } else if (_this.oldPassword == null || _this.oldPassword.length == 0) {
        this.$refs.a.showError(msg.emptyInputPass);
        return false;
      } else if (_this.newPassword.length < 6 && _this.newPassword.length > 0) {
        this.$refs.b.showError(msg.passCountError);
        return false;
      } else if (_this.newPassword == null || _this.newPassword.length == 0) {
        this.$refs.b.showError(msg.emptyInputPass);
        return false;
      } else if (_this.newPassword2 == null || _this.newPassword2.length == 0) {
        this.$refs.c.showError(msg.emptyInputPass);
        return false;
      } else if (_this.newPassword2.length < 6 && _this.newPassword2.length > 0) {
        this.$refs.c.showError(msg.passCountError);
        return false;
      } else if (_this.newPassword2 != _this.newPassword) {
        this.$refs.c.showError(msg.passDisaccord);
        return false;
      }
      return true;
    }
    ,
  }
}
